<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogContent class="sm:max-w-md">
      <div class="flex flex-col items-center text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-full bg-[#F4F3E3]">
          <vue-feather type="check-circle" size="26" class="text-[#4D2542]" />
        </div>

        <DialogHeader class="mt-4 items-center gap-1">
          <DialogTitle class="text-xl">Finished this lesson?</DialogTitle>
          <DialogDescription class="text-[15px] leading-relaxed">
            Mark <span class="font-medium text-gray-700">{{ lectureName }}</span> as complete{{
              hasNext ? ' and jump to the next lesson' : ''
            }}.
          </DialogDescription>
        </DialogHeader>
      </div>

      <DialogFooter class="mt-2 gap-2 sm:justify-center">
        <Button variant="outline" @click="emit('update:open', false)">Not yet</Button>
        <Button class="bg-[#202F7E] text-white hover:bg-[#19246F]" @click="emit('confirm')">
          <vue-feather type="check" size="16" />
          {{ hasNext ? 'Complete & continue' : 'Mark complete' }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

defineProps<{ open: boolean; lectureName: string; hasNext: boolean }>();

const emit = defineEmits<{ 'update:open': [value: boolean]; confirm: [] }>();
</script>
